import styled from "styled-components";
import {
  createStyles,
  makeStyles,
  Typography,
  Chip,
  Grid,
} from "@material-ui/core";

export const MuiGrid = styled(Grid)`
  max-width: 33.33%;
`;
export const MuiChip = styled(Chip)`
  &.MuiChip-root {
    width: 100%;
  }
  .MuiChip-label {
    overflow: hidden;
    line-height: 1.5;
  }
`;

export const SearchLabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 6px 16px;
  color: #fff;
  border-radius: 18px;
  background-color: rgba(255, 255, 255, 0.1);
`;

export const SearchInput = styled.input`
  border: 0;
  padding: 0;
  width: calc(100% - 30px);
  color: inherit;
  font-size: inherit;
  caret-color: #ff5b5b;
  background-color: transparent;
`;

export const SearchForm = styled.form`
  flex: 1;
`;

export const TagLabel = styled(Typography)`
  flex: 1;
  color: #d2d2d3;
  overflow: hidden;
  vertical-align: middle;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-text-size-adjust: none;
`;

export const SearchListNullContainer = styled.section`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d2d2d3;
`;

export const SearchRecommendContainer = styled.section`
  padding: 16px 24px;
`;

export const MuiTypography = styled(Typography)`
  width: 100%;
`;
export const SearchRecommendItem = styled.span`
  position: relative;
  display: block;
  align-items: center;
  width: 100%;
  overflow: hidden;
  vertical-align: middle;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-text-size-adjust: none;
  * {
    margin: 0 10px;
    vertical-align: middle;
  }
`;
export const useListStyle = makeStyles(() =>
  createStyles({
    root: {
      paddingTop: 0,
    },
    item: {
      color: "#d2d2d3",
      padding: "12px 24px",
      borderBottom: "solid 1px #2e3036",
    },
    emptyItem: {
      color: "#717376",
      padding: "12px 24px",
    },
    itemAction: {
      right: "24px",
      color: "#d2d2d3",
    },
  })
);
